import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import {
  VARIETY_CANNED_RESPONSES,
  VARIETY_CUSTOM_SELECT_VALUE,
  isVarietyCannedResponse,
} from "@/lib/variety-options";
import { cn } from "@/lib/utils";

type VarietyFieldProps = {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  className?: string;
  labelClassName?: string;
  selectTriggerClassName?: string;
  textareaClassName?: string;
  disabled?: boolean;
};

export default function VarietyField({
  id = "variety-field",
  value,
  onChange,
  label = "Exercise variety",
  className,
  labelClassName,
  selectTriggerClassName,
  textareaClassName,
  disabled = false,
}: VarietyFieldProps) {
  const selectValue = isVarietyCannedResponse(value) ? value : VARIETY_CUSTOM_SELECT_VALUE;

  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={id} className={labelClassName}>
        {label}
      </Label>
      <Select
        value={selectValue}
        disabled={disabled}
        onValueChange={(next) => {
          if (next === VARIETY_CUSTOM_SELECT_VALUE) {
            if (isVarietyCannedResponse(value)) {
              onChange("");
            }
            return;
          }
          onChange(next);
        }}
      >
        <SelectTrigger id={`${id}-preset`} className={selectTriggerClassName}>
          <SelectValue placeholder="Choose a preset or write your own" />
        </SelectTrigger>
        <SelectContent className="max-w-[min(100vw-2rem,36rem)]">
          <SelectItem value={VARIETY_CUSTOM_SELECT_VALUE}>Custom / none</SelectItem>
          {VARIETY_CANNED_RESPONSES.map((option) => (
            <SelectItem key={option} value={option} className="whitespace-normal py-2 leading-snug">
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Textarea
        id={id}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Choose a preset above, or type custom exercise variety guidance"
        rows={3}
        className={textareaClassName}
      />
    </div>
  );
}
